import axios from 'axios';
const VITALLY_API_KEY =
  'ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmhkV1FpT2lKbE5HTTJaRFJsTWkxbFpERm1MVFExWVdVdFlXTm1NeTA0TkRVNE9UaGlOVGN6TlRraUxDSmhjR2tpT2lJMllUTXdNelpsTkMwMk56TmpMVFExTXpjdE9ETXdPQzAxWVdNM1kyTmlZVFV6T0RJaUxDSnpaV01pT2lKaU5ERmtZbVZtT1NKOS5GSzIzbjV1VVF4RHhZNHNXLXRzQ3R3TnhTZnU0WWJRSThRb1VWSkgyU05zOg==';

export const trackingVitally = async (eventName) => {
  try {
    await axios.post('/api/track', { eventName });
  } catch (error) {
    console.error('trackingVitally error: ', error);
  }
};

// https://docs.vitally.io/en/articles/9836612-installing-configuring-nps
const VitallyNPSOptions = {
  productName: 'Rich Returns',
  autoLoadSegment: false, // Set to true if using Segment
  delay: 1000, // Delay in milliseconds before showing the survey
};


export const initVitally = (userData) => {
  const { CompanyId, shopifyProfileEmail, createdAt, plan_name } = userData;
  const forceTrackingStoreDevelopment = [66, 6115, 4848];
  // Only init at first load when data is ready
  if (
    VITALLY_API_KEY &&
    CompanyId &&
    !window.Vitally &&
    (plan_name !== 'partner_test' ||
      forceTrackingStoreDevelopment.includes(CompanyId))
  ) {
    // Add Vitally script
    const vitallyScript = document.createElement('script');
    vitallyScript.src = 'https://cdn.vitally.io/vitally.js/v1/vitally.js';
    vitallyScript.async = true;
    document.body.appendChild(vitallyScript);
    const id = `RR_${CompanyId}`;

    vitallyScript.onload = () => {
      // Initialize Vitally NPS
      window.Vitally = window.Vitally || [];
      window.Vitally.init(
        VITALLY_API_KEY,
        'https://clearer.api.vitally.io/analytics/v1'
      );
      window.Vitally.account({ accountId: id, traits: { createdAt } });
      window.Vitally.user({
        userId: id,
        accountId: id,
        traits: { email: shopifyProfileEmail, createdAt },
      });

      console.log('initVitally()', { accountId: id, CompanyId });

      // show survey based on rules configured in Vitally dashboard
      window.Vitally.nps('survey', VitallyNPSOptions);

      // force show to test at local
      // window.Vitally.nps('show', VitallyNPSOptions);
    };
  }
};
